import React, { Fragment, useCallback, useEffect, useState } from 'react'
import ShowStory from '../show-story/index'
import Pagination from 'react-js-pagination'
import TestimonialCard from '../testimonial-card/index'
import PropTypes from 'prop-types'

import styles from './testimonials-list.module.scss'

export default function Index ({ data, type }) {
  const [modalShow, setModalShow] = useState(false)
  const [activeItem, setActiveItem] = useState(null)
  const [activePage, setActivePage] = useState(1)
  // eslint-disable-next-line no-unused-vars
  const [itemPerPage, setItemPerPage] = useState(12)
  const [offset, setOffset] = useState(0)
  const [displayedImages, setDisplayedImages] = useState([])
  const [images, setImages] = useState(data || [])

  const handlePageChange = useCallback((pageNumber) => {
    console.log(`active page is ${pageNumber}`)
    setActivePage(pageNumber)
    setOffset((pageNumber - 1) * itemPerPage)
  }, [itemPerPage])

  useEffect(() => {
    // on change list of image, reset page number
    setOffset(0)
    setActiveItem(null)
  }, [images])

  useEffect(() => {
    // on change page number, set list images to display
    const displayed = images.slice(offset, (offset + itemPerPage))
    setDisplayedImages(displayed)
  }, [offset, images])

  return (
    <Fragment>
      <div className={styles['testimonials-list']}>
        <div className='row justify-content-center'>
          {!displayedImages.length && <div className={'p-5 text-center text-light'}>No Testimonials</div>}
          {displayedImages &&
        displayedImages.length > 0 &&
        displayedImages.map((image, index) => {
          return (
            <TestimonialCard key={index} item={image} setModalShow={setModalShow} setActiveItem={setActiveItem}/>
          )
        })}
          {activeItem && <ShowStory
            key={`story-${activeItem.id}`}
            show={modalShow}
            onHide={() => setModalShow(false)}
            testimonial={activeItem}
          />}
        </div>
        <div className={'justify-content-center'}>
          <Pagination
            hideFirstLastPages
            itemClass='page-item'
            linkClass='page-link'
            itemClassPrev='prev'
            itemClassNext='next'
            prevPageText={
              <span aria-hidden="true">‹</span>
            }
            nextPageText={
              <span aria-hidden="true">›</span>
            }
            activePage={activePage}
            itemsCountPerPage={itemPerPage}
            totalItemsCount={images.length}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </Fragment>
  )
}

Index.propTypes = {
  type: PropTypes.string
}
